module.exports = __webpack_public_path__ + "img/zangzu.32679b24.jpg";